import React from 'react';

const PageLabel: React.FC<React.HTMLProps<HTMLLabelElement>> = (props) => {
  return <label className="typography_label" {...props} />;
};

export default PageLabel;
